module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/14-e90ba4f6490ebb62f2204244a88a0179.jpg";